import BaseType from "./BaseType";
import ArrangementRuler from "./ArrangementRuler";

export default class Arrangment extends BaseType(THREE.Group) {

    ruler: ArrangementRuler;
    schraenke: Object3d;
    raum: ?Object3d;

    constructor(vsData) {
        super(vsData);
        this.name = 'Arrangement';
        this.schraenke = new THREE.Group();
        this.add(this.schraenke);
        this.ruler = new ArrangementRuler(vsData);
        this.add(this.ruler);
    }

}
